import { DOT_STYLE, STROKE_STYLE } from './LineChart.types';
import { CircularDot, ShurikenDot, SquareDot, TriangularDot } from './LineChartDots';
export const dotStyles = {
  [DOT_STYLE.CIRCULAR]: {
    transform: 'translate(-50%, -40%)',
    height: '8px',
    width: '8px'
  },
  [DOT_STYLE.TRIANGULAR]: {
    transform: 'translate(-50%, -50%)',
    height: '10px',
    width: '10px'
  },
  [DOT_STYLE.SQUARE]: {
    transform: 'translate(-50%, -40%)',
    height: '8px',
    width: '8px'
  },
  [DOT_STYLE.SHURIKEN]: {
    transform: 'translate(-50%, -40%)',
    width: '13px',
    height: '12px'
  }
};

// Helps us to inline the styled dots with text, which are rendered in chart tooltip and chart legends
export const styledDotInlineCoordinates = {
  [DOT_STYLE.CIRCULAR]: {
    cx: 4,
    cy: 4
  },
  [DOT_STYLE.TRIANGULAR]: {
    cx: 5,
    cy: 5
  },
  [DOT_STYLE.SQUARE]: {
    cx: 4,
    cy: 4
  },
  [DOT_STYLE.SHURIKEN]: {
    cx: 6.5,
    cy: 6
  }
};
export const strokeArrayMap = {
  [STROKE_STYLE.SOLID]: '',
  [STROKE_STYLE.DASHED]: '6 2',
  [STROKE_STYLE.DOTTED]: '2 1'
};
export const customDots = {
  [DOT_STYLE.CIRCULAR]: CircularDot,
  [DOT_STYLE.SQUARE]: SquareDot,
  [DOT_STYLE.TRIANGULAR]: TriangularDot,
  [DOT_STYLE.SHURIKEN]: ShurikenDot
};
export const getStyledDotInlineCoordinates = dotStyle => styledDotInlineCoordinates[dotStyle];
export const getStrokeStyles = (color, strokeStyle) => {
  return {
    border: "1px ".concat(strokeStyle, " ").concat(color)
  };
};
export const getDotStyles = dotStyle => dotStyles[dotStyle];
export const getStrokeDashArray = strokeStyle => strokeArrayMap[strokeStyle];